// extracted by mini-css-extract-plugin
export default {"text":"text__68bc3ffe","link":"link__68bc3ffe"};